module.exports = __webpack_public_path__ + "img/map-content.733b9758.png";